import { render, staticRenderFns } from "./user-followup-1_new.vue?vue&type=template&id=1ee01386&scoped=true"
import script from "./user-followup-1_new.vue?vue&type=script&lang=js"
export * from "./user-followup-1_new.vue?vue&type=script&lang=js"
import style0 from "./user-followup-1_new.vue?vue&type=style&index=0&id=1ee01386&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee01386",
  null
  
)

export default component.exports